import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-kasa-close',
  templateUrl: './kasa-close.component.html',
  styleUrls: ['./kasa-close.component.scss']
})
export class KasaCloseComponent implements OnInit  {

  public isLoaded = true;
  public services: Kasa[];
  public kasa: Kasa;
  public onClose: Subject<void> = new Subject();

   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal ,public wtStore:WtStorageService,public client:KasaClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      startAmount: [this.kasa.startAmount, Validators.required],
      createdOn: [this.kasa.createdOn, Validators.required],
      endAmount: [this.kasa.amount, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next();
    this.activeModal.close();
  }
  onSubmit() {
    if (this.Form.valid) {

      let service =new Kasa();
      service.closeAmount = this.Form.value.endAmount;
      service.idKasa = this.kasa.idKasa;

      this.client.closeCasa(service).subscribe((user) => {
        this.activeModal.close();
        this.onClose.next();
      });
    }
  }

}
